var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Badge from '@material-ui/core/Badge';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { notificationGlobalData } from '../../../store/notification/reducer';
import { notificationGlobalSuccess } from '../../../store/notification/actions';
import { getNotificationData, markAsReadAllNotification, markAsReadNotification, deleteNotification } from '../../../services/notification-service';
import InfiniteScroll from 'react-infinite-scroll-component';
import { notificationSimple } from '../../../utils/CommonUtil';
import * as Constant from '../../../utils/Constant';
import * as LocalStorageUtil from '../../../utils/LocalStorageUtil';
import { formatDistanceToNow } from 'date-fns';
var NotificationDropdown = function (props) {
    var t = useTranslation().t;
    var history = useHistory();
    var notificationGlobalCountData = props.notificationGlobalCountData;
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var _b = useState(false), isLoading = _b[0], setLoading = _b[1];
    var _c = useState(true), hasMore = _c[0], setMore = _c[1];
    var _d = useState([]), notificationData = _d[0], setNotificationData = _d[1];
    var _e = useState({
        size: 10
    }), notificationOption = _e[0], setOption = _e[1];
    var _f = useState(0), numberNotRead = _f[0], setNumberNotRead = _f[1];
    var _g = useState({
        minId: null
    }), paramInfinite = _g[0], setParamInfinite = _g[1];
    var _h = useState(false), isLoadingMarkAsReadAll = _h[0], setLoadingMarkAsReadAll = _h[1];
    var useOutsideAlerter = function (ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    };
    var notificationRef = useRef(null);
    useOutsideAlerter(notificationRef);
    useEffect(function () {
        getNotification("DEFAULT");
    }, []);
    useEffect(function () {
        setNumberNotRead(notificationGlobalCountData);
    }, [notificationGlobalCountData]);
    var getNotification = function (type) { return __awaiter(void 0, void 0, void 0, function () {
        var paramData, params, data, notificationPush, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    paramData = __assign({}, paramInfinite);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setLoading(true);
                    params = {
                        size: notificationOption.size
                    };
                    if (paramData.minId && !type) {
                        params.minId = paramData.minId;
                    }
                    return [4 /*yield*/, getNotificationData(params)];
                case 2:
                    data = _a.sent();
                    notificationPush = type ? data : notificationData.concat(data);
                    if (data && data.length == 10) {
                        paramData.minId = data[data.length - 1].id;
                        setParamInfinite(paramData);
                    }
                    setMore(data.length == 10);
                    setNotificationData(notificationPush);
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleClick = function (event) {
        setOpen(!open);
        if (!open) {
            getNotification("DEFAULT");
        }
    };
    var redirectToAction = function (url) {
        var location = {
            pathname: url,
        };
        history.push(location);
    };
    var onClickDeleteNotification = function (event, notification) { return __awaiter(void 0, void 0, void 0, function () {
        var notificationsClearData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    event.stopPropagation();
                    if (!confirm("Are you sure that you want to delete this notification?")) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteNotification(notification.id)];
                case 2:
                    _a.sent();
                    if ((!notification.toUsers || !notification.toUsers.length || 'SEEN' != notification.toUsers[0].status) && numberNotRead) {
                        props.dispatch(notificationGlobalSuccess(numberNotRead - 1));
                    }
                    notificationsClearData = notificationData.filter(function (notify) {
                        if (notify.id == notification.id) {
                            return false;
                        }
                        return true;
                    });
                    setNotificationData(notificationsClearData);
                    notificationSimple("Delete Notification Success!", Constant.NOTIFICATION_SUCCESS);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log("Error delete Notification");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onClickNotification = function (event, notification) {
        if (!notification.toUsers || !notification.toUsers.length || 'SEEN' != notification.toUsers[0].status) {
            onClickMarkAsRead(notification);
        }
        else {
            if (notification.link) {
                if (notification.link.indexOf("/report-queue") > -1) {
                    redirectToAction("/report-queue");
                }
                else if (notification.link.indexOf("/alert") > -1 && notification.link.indexOf("/detail") > -1) {
                    var alertUrl = "/alert/" + notification.id + "/detail";
                    var paramAlertDetail = {
                        index: 0,
                        data: notification
                    };
                    LocalStorageUtil.storeItem(LocalStorageUtil.ALERT_KEY, JSON.stringify(paramAlertDetail));
                    redirectToAction(alertUrl);
                }
            }
        }
    };
    var onClickMarkAsRead = function (notification) { return __awaiter(void 0, void 0, void 0, function () {
        var notificationClearData, alertUrl, paramAlertDetail, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, markAsReadNotification(notification.id)];
                case 1:
                    _a.sent();
                    if (numberNotRead) {
                        props.dispatch(notificationGlobalSuccess(numberNotRead - 1));
                    }
                    notificationClearData = notificationData.map(function (notify) {
                        if (notify && notify.id == notification.id && notify.toUsers && notify.toUsers.length) {
                            notify.toUsers[0].status = 'SEEN';
                        }
                        return notify;
                    });
                    setNotificationData(notificationClearData);
                    if (notification.link) {
                        if (notification.link.indexOf("/report-queue") > -1) {
                            redirectToAction("/report-queue");
                        }
                        else if (notification.link.indexOf("/alert") > -1 && notification.link.indexOf("/detail") > -1) {
                            alertUrl = "/alert/" + notification.id + "/detail";
                            paramAlertDetail = {
                                index: 0,
                                data: notification
                            };
                            LocalStorageUtil.storeItem(LocalStorageUtil.ALERT_KEY, JSON.stringify(paramAlertDetail));
                            redirectToAction(alertUrl);
                        }
                    }
                    notificationSimple("Mark as Read Success!", Constant.NOTIFICATION_SUCCESS);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.log("Mark All Notification Error");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onClickMarkAllAsRead = function () { return __awaiter(void 0, void 0, void 0, function () {
        var notificationClearData, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoadingMarkAsReadAll)
                        return [2 /*return*/];
                    setLoadingMarkAsReadAll(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, markAsReadAllNotification()];
                case 2:
                    _a.sent();
                    if (numberNotRead) {
                        props.dispatch(notificationGlobalSuccess(null));
                    }
                    notificationClearData = notificationData.map(function (notify) {
                        if (notify && notify.toUsers && notify.toUsers.length) {
                            notify.toUsers[0].status = 'SEEN';
                        }
                        return notify;
                    });
                    setNotificationData(notificationClearData);
                    notificationSimple("Mark All as Read Success!", Constant.NOTIFICATION_SUCCESS);
                    setLoadingMarkAsReadAll(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    console.log("Mark All Notification Error");
                    setLoadingMarkAsReadAll(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onClickSeeAll = function (event) {
        history.push("/notifications");
    };
    return (React.createElement("div", { className: "dropdowns-wrapper", ref: notificationRef },
        React.createElement("div", { className: "dropdown-container" },
            React.createElement("div", { className: "notifications dropdown dd-trigger", "ng-click": "showNotifications($event)" },
                React.createElement(IconButton, { "aria-label": "Notification", onClick: handleClick, component: "span", className: "notification-icon" },
                    React.createElement(Badge, { overlap: 'rectangular', badgeContent: numberNotRead, color: "primary", classes: { badge: 'content-badge-notfication' } },
                        React.createElement(NotificationsIcon, null)))),
            open && (React.createElement("div", { className: "custom-select-notification arrow", style: { position: "absolute", zIndex: 99999999 } },
                React.createElement("div", { className: "dropdown-header" },
                    React.createElement("span", { className: "triangle" }),
                    React.createElement("span", { className: "heading" }, "Notifications")),
                React.createElement("div", { className: "dropdown-body", id: "scrollableNotification" },
                    React.createElement(InfiniteScroll, { dataLength: notificationData.length, next: getNotification, hasMore: hasMore, loader: React.createElement("div", { className: 'text-center' },
                            React.createElement(CircularProgress, { size: 20 })), scrollableTarget: "scrollableNotification", endMessage: React.createElement("p", { className: 'text-center' },
                            React.createElement("b", null, "Yay! You have seen it all")) }, notificationData && notificationData.length ? notificationData.map(function (notification, index) {
                        return React.createElement("div", { key: index, className: "notification " + (notification && notification.toUsers && notification.toUsers.length && notification.toUsers[0].status === "SEEN" ? "" : "new"), onClick: function (e) { return onClickNotification(e, notification); } },
                            React.createElement("div", { className: "notification-image-wrapper" },
                                React.createElement("div", { className: "notification-image" }, notification.iconUrl ? React.createElement("img", { src: notification.iconUrl, alt: "", width: "32" }) : React.createElement(NotificationsIcon, null))),
                            React.createElement("div", { className: "notification-text" },
                                React.createElement("p", null, notification.message),
                                React.createElement("p", { className: 'from-time-text' }, formatDistanceToNow(new Date(notification.createdDate))),
                                React.createElement("p", { className: 'delete-icon' },
                                    React.createElement(Tooltip, { title: "Delete", enterDelay: 500, leaveDelay: 200 },
                                        React.createElement(IconButton, { "aria-label": "Notification", onClick: function (event) { return onClickDeleteNotification(event, notification); }, component: "span", className: "notification-icon" },
                                            React.createElement(HighlightOffIcon, { className: "icon-size-alert" }))))));
                    }) : null)),
                React.createElement("div", { className: "dropdown-footer" },
                    React.createElement("a", { className: 'text-primary mark-as-read-btn', onClick: onClickSeeAll },
                        React.createElement("span", { className: 'text-mark-as-read' }, "See All")),
                    React.createElement("a", { className: 'text-primary mark-as-read-btn', onClick: onClickMarkAllAsRead },
                        isLoadingMarkAsReadAll ? React.createElement(CircularProgress, { size: 10 }) : null,
                        React.createElement("span", { className: 'text-mark-as-read' }, "Mark All as Read")))))),
        React.createElement("div", { className: "dropdown-container" },
            React.createElement("div", { className: "messages dropdown" },
                React.createElement("span", { className: "fa fa-envelope-o" })))));
};
function mapStateToProps(state) {
    return {
        notificationGlobalCountData: notificationGlobalData(state)
    };
}
export default connect(mapStateToProps)(NotificationDropdown);
